export const NewsColumns = [
    {
        name: "ThumbNail",
        id: "thumb"
    },
    {
        name: "Título",
        id: "title"
    },
    {
        name: "Link Externo",
        id: "externLink"
    }
];